import React, { useEffect, useState } from 'react';
import { blue } from '@mui/material/colors';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  dark?: boolean;
}

const Theme: React.FC<Props> = ({ children, ...rest }: Props) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: '#1890ff',
      },
      secondary: blue,
      text: {
        secondary: '#000000db',
      },
      warning: {
        main: '#F7B500',
      },
      error: {
        main: '#f44336',
      },
      success: {
        main: '#6DD400',
      },
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          colorPrimary: {
            backgroundColor: 'rgba(4, 109, 57, 0.05)',
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            minHeight: 56,
          },
        },
      },
    },
  });
  // background: 'url(/background.webp) no-repeat center center fixed'
  return (
    <div {...rest} style={{ height: '100vh', background: 'white' }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </div>
  );
};

export default Theme;
